export default "__VITE_ASSET__b53dc8cf__"